import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Download } from "lucide-react";
import { PageHeader, Spinner, Table, THead, TR, TH, TD, Badge, KPICard, SecondaryButton } from "./_ui";
import { CreditCard, Wallet, CheckCircle2 } from "lucide-react";

export default function CotisationsPanel() {
  const [tx, setTx] = useState(null);
  useEffect(() => { api.get("/admin/donations").then((r) => setTx(r.data)); }, []);
  if (!tx) return (<><PageHeader title="Cotisations & Dons" /><Spinner /></>);

  const paid = tx.filter((t) => t.payment_status === "paid");
  const totalPaid = paid.reduce((s, t) => s + (t.amount || 0), 0);
  const cotisCount = paid.filter((t) => t.purpose === "cotisation").length;

  const exportCSV = () => {
    const rows = [
      ["Date", "Email", "Désignation", "Méthode", "Statut", "Montant USD"],
      ...tx.map((t) => [
        new Date(t.created_at).toISOString(),
        t.user_email || "",
        t.label || t.purpose || "",
        t.method || "",
        t.payment_status || "",
        String(t.amount || 0),
      ]),
    ];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `afb-cotisations-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-cotisations">
      <PageHeader
        title="Cotisations & Dons"
        subtitle="Toutes les transactions financières du mouvement (Stripe + Mobile Money)."
        action={<SecondaryButton onClick={exportCSV} data-testid="cotis-export"><Download size={14} /> Exporter CSV</SecondaryButton>}
      />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <KPICard icon={CheckCircle2} label="Transactions confirmées" value={paid.length} color="green" />
        <KPICard icon={CreditCard} label="Cotisations versées" value={cotisCount} color="blue" />
        <KPICard icon={Wallet} label="Total encaissé (USD)" value={`$${totalPaid.toFixed(2)}`} color="gold" />
      </div>

      <Table>
        <THead><tr><TH>Date</TH><TH>Email</TH><TH>Désignation</TH><TH>Méthode</TH><TH>Statut</TH><TH className="text-right">Montant</TH></tr></THead>
        <tbody>
          {tx.map((t) => (
            <TR key={t.session_id}>
              <TD className="text-xs">{new Date(t.created_at).toLocaleDateString("fr-FR")}</TD>
              <TD>{t.user_email || "—"}</TD>
              <TD>{t.label || t.purpose}</TD>
              <TD className="text-xs">{t.method?.replace(/_/g, " ")}</TD>
              <TD>
                <Badge color={
                  t.payment_status === "paid" ? "green" :
                  t.payment_status === "pending_otp" ? "blue" : "slate"
                }>{t.payment_status}</Badge>
              </TD>
              <TD className="text-right font-display text-base text-white">${t.amount}</TD>
            </TR>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
